module.exports = __webpack_public_path__ + "img/gk_img1.63fcf73e.png";